import { SCOPE_NAME } from '.';
export var getSidebarItems = function (state) {
    return state[SCOPE_NAME].sidebarItems;
};
export var getSidebarOpen = function (state) {
    return state[SCOPE_NAME].sidebarOpen;
};
export var getMobileMenuExpanded = function (state) {
    return state[SCOPE_NAME].mobileMenuExpanded;
};
export var getUserMenuLayouts = function (state) {
    return state[SCOPE_NAME].userMenuLayouts;
};
export var getActiveTaskId = function (state) {
    return state[SCOPE_NAME].activeTaskId;
};
export var getDrawerOpen = function (state) {
    return state[SCOPE_NAME].drawerOpen;
};
